import React from "react";
import { Outlet } from "react-router-dom";

const IniciativasEstrategicas: React.FC = () => {
  return <Outlet />;
};

export default IniciativasEstrategicas;
